import React from 'react'
import { Block, Typography } from '@xprog/prensa'

import { TopbarItemContainerProps, TopbarItemLabelProps } from './TopbarItems.types'

export const TopbarItemContainer: React.FC<TopbarItemContainerProps> = (props) => {
  return (
    <Block as='nav'>
      <Block
        as='ul'
        css={{
          align: ['row', 'center', 'middle'],
          my: '$0',
          px: '$0',
          'list-style-type': 'none'
        }}
      >
        {props.children}
      </Block>
    </Block>
  )
}

export const TopbarItemLabel: React.FC<TopbarItemLabelProps> = (props) => {
  return (
    <Typography
      as='span'
      variant='menuTag-default'
      css={{ fontFamily: '$tertiary', ...props.css }}
    >
      {props.children}
    </Typography>
  )
}